<template>
  <div class="monitor-config-container">

    <div class="operation-header">
      <el-row :gutter="20">
        <el-col :span="3" :offset="0">
          <h3>操作：</h3>
        </el-col>
        <el-col :span="3" :offset="18">
          <el-button type="primary" @click="saveRule">保存</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="section-add-global-rule">
      <h4>全局配置项</h4>
      <div class="form-row">
        <span>选择可配置项：</span>
        <el-select v-model="other_value" placeholder="请选择" class="select-medium">
          <el-option v-for="item in otherSelect" :key="item.key" :label="item.title" :value="item.key">
          </el-option>
        </el-select>
        <el-button type="primary" plain @click="addOther">增加</el-button>
      </div>
    </div>

    <el-divider></el-divider>

    <el-row :gutter="15" class="config-row">
      <el-col v-if="'maxDelay' in others" :span="8">
        <div class="config-item">
          <span class="config-label">数据上报的最大延时秒数：</span>
          <el-input placeholder="请填写" v-model="others['maxDelay']" class="input-small">
          </el-input>
          <el-button type="danger" size="mini" icon="el-icon-delete" plain circle @click="removeOther('maxDelay')" class="remove-btn">
          </el-button>
        </div>
      </el-col>
    </el-row>

    <el-divider></el-divider>

    <div class="section-field-config">
      <h4>字段配置 <span v-if="fields" class="count-info">(已配置 {{ totalCfgItemsCount }} 个规则)</span></h4>

      <div class="form-row">
        <span>数据字段：</span>
        <el-select v-model="field_value" placeholder="请选择字段" class="select-medium">
          <el-option v-for="(item,key) in fields" :key="key" :label="item.title + (item.cfg && Object.keys(item.cfg).length > 0 ? ' (' + Object.keys(item.cfg).length + ')' : '')" :value="key">
          </el-option>
        </el-select>

        <span>选择可配置项：</span>
        <el-select v-model="rule_value" placeholder="请选择" class="select-medium">
          <el-option v-for="item in ruleSelect" :key="item.key" :label="item.title" :value="item.key">
          </el-option>
        </el-select>

        <el-button type="primary" plain @click="addRole">增加</el-button>
      </div>
    </div>

    <el-divider></el-divider>

    <div v-if="field_value!=''" class="field-rule-section">
      <el-row :gutter="15" class="config-row">
        <el-col :span="8" v-if="'mustExist' in fields[field_value]['cfg']">
          <div class="config-item">
            <span class="config-label">字段必须存在</span>
            <el-checkbox :value="!!fields[field_value]['cfg'].mustExist" @change="val => updateFieldValue('mustExist', val)" />
            <el-button type="danger" size="mini" icon="el-icon-delete" plain circle @click="removeRule('mustExist')" class="remove-btn">
            </el-button>
          </div>
        </el-col>
        <el-col :span="8" v-if="'mustNotEmpty' in fields[field_value]['cfg']">
          <div class="config-item">
            <span class="config-label">字段不能为空</span>
            <el-checkbox :value="!!fields[field_value]['cfg'].mustNotEmpty" @change="val => updateFieldValue('mustNotEmpty', val)" />
            <el-button type="danger" size="mini" icon="el-icon-delete" plain circle @click="removeRule('mustNotEmpty')" class="remove-btn">
            </el-button>
          </div>
        </el-col>
        <el-col :span="8" v-if="'mustBeNumber' in fields[field_value]['cfg']">
          <div class="config-item">
            <span class="config-label">必须为数字</span>
            <el-checkbox :value="!!fields[field_value]['cfg'].mustBeNumber" @change="val => updateFieldValue('mustBeNumber', val)" />
            <el-button type="danger" size="mini" icon="el-icon-delete" plain circle @click="removeRule('mustBeNumber')" class="remove-btn">
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="config-row">
        <el-col :span="8" v-if="'min' in fields[field_value]['cfg']">
          <div class="config-item">
            <span class="config-label">最小数值：</span>
            <el-input placeholder="最小数值" v-model="fields[field_value]['cfg'].min" class="input-small">
            </el-input>
            <el-button type="danger" size="mini" icon="el-icon-delete" plain circle @click="removeRule('min')" class="remove-btn">
            </el-button>
          </div>
        </el-col>
        <el-col :span="8" v-if="'max' in fields[field_value]['cfg']">
          <div class="config-item">
            <span class="config-label">最大数值：</span>
            <el-input placeholder="最大数值" v-model="fields[field_value]['cfg'].max" class="input-small">
            </el-input>
            <el-button type="danger" size="mini" icon="el-icon-delete" plain circle @click="removeRule('max')" class="remove-btn">
            </el-button>
          </div>
        </el-col>
        <el-col :span="8" v-if="'mcr' in fields[field_value]['cfg']">
          <div class="config-item">
            <span class="config-label">最大分钟变化：</span>
            <el-input placeholder="例:1/s" v-model="fields[field_value]['cfg'].mcr" class="input-small">
            </el-input>
            <el-button type="danger" size="mini" icon="el-icon-delete" plain circle @click="removeRule('mcr')" class="remove-btn">
            </el-button>
          </div>
          <div class="help-text"> <span>(可以/s、/m、/h结尾表示秒，分，时)</span> </div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      fields: {},
      others: {},
      other_value: '',
      field_value: '',
      rule_value: '',
      otherSelect: [{
        key: 'maxDelay',
        title: '数据上报的最大延时秒数'
      },],
      ruleSelect: [
        {
          key: 'mustExist',
          title: '字段必须存在'
        },
        {
          key: 'mustNotEmpty',
          title: '字段不能为空'
        },
        {
          key: 'mustBeNumber',
          title: '必须为数字'
        },
        {
          key: 'min',
          title: '最小值'
        },
        {
          key: 'max',
          title: '最大值'
        },
        {
          key: 'mcr',
          title: '最大分钟变化'
        },
      ],
      selectType: '',
      groupId: '',
      uid: '',
    }
  },
  watch: {
    '$store.state.curTreeData': {
      handler(val) {
        const curData = val[0];
        //选择了节点
        if (curData.type == "org" && curData.groupId) {
          this.checkProfile({ groupId: curData.groupId })
          this.groupId = curData.groupId;
          this.selectType = 'org';
        }
        //选择了设备
        if (curData.type == "device") {
          this.checkProfile({ uid: curData.uid })
          this.uid = curData.uid;
          this.selectType = 'device';
        }
        this.cleanData();
      }
    },
  },
  methods: {
    //新增全局规则
    addOther() {
      if (this.other_value == '') {
        this.$message.error('请先选择可配置字段');
        return
      }
      // 使用 Vue.set 或 this.$set 确保响应性
      this.$set(this.others, this.other_value, '');
    },
    //增加规则
    addRole() {
      // console.log(555, this.fields);

      if (!this.fields) {
        this.$message.error('fields无数据');

        return
      }
      if (this.field_value == '') {
        this.$message.error('请先选择数据字段');
        return
      }
      if (this.rule_value == '') {
        this.$message.error('请先选择规则');
        return
      }
      // 使用 Vue.set 或 this.$set 确保响应性
      this.$set(this.fields[this.field_value].cfg, this.rule_value, 1);
      // 强制更新视图
      this.$forceUpdate();
    },
    //删除规则
    removeRule(key) {
      if (this.field_value && this.fields[this.field_value] && this.fields[this.field_value].cfg) {
        // 删除对应的配置项
        this.$delete(this.fields[this.field_value].cfg, key);
      }
      // 强制更新视图
      this.$forceUpdate();
    },
    //删除全局规则
    removeOther(key) {
      this.$delete(this.others, key);
    },
    //存储规则
    saveRule() {
      if (this.groupId == '' && this.uid == '') {
        this.$message.error('请选择设备或分组');
        return
      }
      // 创建转换后的配置对象
      const convertedConfig = {
        fields: {}
      };

      // 转换 fields 对象，取 key 和 cfg 值
      Object.keys(this.fields).forEach(key => {
        const cfg = this.fields[key].cfg;
        // 检查 cfg 是否存在且不为空对象
        if (cfg && typeof cfg === 'object' && Object.keys(cfg).length > 0) {
          convertedConfig.fields[key] = cfg;
        }
      });

      // 如果 maxDelay 有值，则添加到配置对象中
      if (this.others.maxDelay != null && this.others.maxDelay !== '') {
        convertedConfig.maxDelay = this.others.maxDelay;
      }
      // 处理 others 对象中的所有配置项
      // Object.keys(this.others).forEach(key => {
      //   const value = this.others[key];
      //   if (value != null) {
      //     convertedConfig[key] = value;
      //   }
      // });
      let id = this.selectType == 'org' ? 'group_' + this.groupId : this.uid;
      let json = {
        'cmd': "setDataStore",
        "id": id,
        "tag": "monitor",
        "data": convertedConfig
      }
      console.log('setDataStore:', json);
      this.ws.send(json);
    },
    updateFieldValue(field, value) {
      if (this.field_value && this.fields[this.field_value] && this.fields[this.field_value].cfg) {
        this.fields[this.field_value].cfg[field] = value ? 1 : 0;
      }
    },
    //获取可用规则
    checkProfile(val) {
      let json = {
        "cmd": "checkProfile",
        //"groupId": 288,//groupId和uid二选一
        //"uid":"XGW00938XMF"
      }
      if (val.groupId) {
        json.groupId = val.groupId;
      }
      if (val.uid) {
        json.uid = val.uid;
      }
      this.ws.send(json);
    },
    //获取设备规则
    getDataStore() {
      let id = this.selectType == 'org' ? 'group_' + this.groupId : this.uid;

      let json = {
        "cmd": "dataStore",
        "id": id,
        "tag": "monitor",
      }
      this.ws.send(json);
    },
    cleanData() {
      this.fields = {};
      this.others = {};
      this.other_value = '';
      this.field_value = '';
      this.rule_value = '';

    },
  },
  computed: {
    totalCfgItemsCount() {
      if (!this.fields) return 0;

      let count = 0;
      Object.keys(this.fields).forEach(key => {
        const cfg = this.fields[key].cfg;
        if (cfg && typeof cfg === 'object') {
          count += Object.keys(cfg).length;
        }
      });

      return count;
    }
  },
  created() {
    this.getDataStore();
  },
  mounted() {
    //返回存储规则
    this.ws.addCallback('dataStoreAck', (res) => {
      let id = this.selectType == 'org' ? 'group_' + this.groupId : this.uid;
      const items = res.items;
      if (items.length == 0 || items[0].id != id) {
        return
      }

      if (items[0].data) {
        // 解析返回的数据
        const configData = items[0].data;
        // 设置最大延迟时间
        if (configData.maxDelay) {
          this.others.maxDelay = configData.maxDelay;
        }
        // 更新 fields 中每个设备类型的配置
        if (configData.fields) {
          Object.keys(configData.fields).forEach(deviceType => {
            if (this.fields[deviceType]) {
              // 使用 $set 来确保响应式更新
              Object.keys(configData.fields[deviceType]).forEach(key => {
                this.$set(this.fields[deviceType].cfg, key, configData.fields[deviceType][key]);
              });
            }
          });
        }
        // 触发界面更新
        this.$forceUpdate();

      }

    })
    //返回设置规则是否成功
    this.ws.addCallback('setDataStoreAck', (res) => {
      this.$message.success('保存数据成功!');


    })
    //返回可用配置
    this.ws.addCallback('checkProfileAck', (res) => {
      console.log(467, res);
      if (res.fields) {
        // 为字段配置添加默认值
        const fieldsWithDefaults = {};
        for (const key in res.fields) {
          const field = res.fields[key];
          // 初始化配置对象，确保所有验证字段都有默认值
          if (!field.cfg) {
            // 使用 this.$set 确保响应性
            this.$set(field, 'cfg', {});
          } else {
            // 使用 this.$set 确保现有配置的响应性
            this.$set(this.fields, key, field);
          }
          fieldsWithDefaults[key] = field;
        }
        // 使用 this.$set 替代直接赋值，确保响应性
        Object.keys(fieldsWithDefaults).forEach(key => {
          this.$set(this.fields, key, fieldsWithDefaults[key]);
        });
      }
      //请求保存的数据
      this.getDataStore();
    })

  },
}
</script>

<style lang="scss" scoped>
.monitor-config-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.operation-header {
  margin-bottom: 20px;
  h3 {
    margin: 0;
    font-size: 18px;
    color: #303133;
  }
}

.section-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
}

.section-add-global-rule,
.section-field-config {
  margin-bottom: 15px;

  h4 {
    margin-bottom: 15px;
    font-size: 16px;
    color: #303133;
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 8px;

    .count-info {
      font-size: 14px;
      color: #909399;
      font-weight: normal;
    }
  }

  .form-row {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;

    > span {
      font-size: 14px;
      color: #606266;
      margin-right: 8px;
      white-space: nowrap;
    }

    .select-medium {
      width: 200px;
    }
  }
}

.field-rule-section {
  margin-top: 20px;
  padding: 15px;
  background-color: #fafafa;
  border-radius: 4px;
}

.config-row {
  margin-bottom: 15px;
}

.config-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  background-color: #fff;
  border-radius: 4px;
  transition: all 0.3s;
  border: 1px solid #ebeef5;
  margin-bottom: 10px;

  &:hover {
    border-color: #c0c4cc;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  }

  .config-label {
    margin-right: 10px;
    font-weight: 500;
    color: #606266;
    min-width: 100px;
    flex-shrink: 0;
  }

  .el-checkbox,
  .el-input {
    flex-shrink: 0;
  }

  .input-small {
    width: 150px;
    margin-right: 10px;
  }

  .remove-btn {
    margin-left: 10px;
  }
}

.help-text {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  padding-left: 150px; // 与 config-label 的宽度对齐
}

// 响应式调整
@media (max-width: 768px) {
  .config-item {
    flex-direction: column;
    align-items: flex-start;

    .config-label {
      display: block;
      margin-bottom: 8px;
    }

    .input-small {
      width: 100%;
      margin-right: 0;
    }
  }

  .form-row {
    flex-direction: column;
    align-items: stretch;

    > span {
      margin-bottom: 5px;
      margin-right: 0;
    }

    .select-medium {
      width: 100% !important;
      margin-bottom: 10px;
    }
  }
}
</style>